import { selectors } from '../selectors'
import { openBacktestRunDialogDirectly } from './directAccess'
import { isElementReady } from './elementUtils'

export const autoClickSidePanelTab = (tabSelector: string): void => {
  if (!isElementReady(tabSelector)) return

  const tabElement = document.querySelector(tabSelector) as HTMLElement
  const isAlreadyActive =
    tabElement.classList.contains('Mui-selected') ||
    tabElement.getAttribute('aria-selected') === 'true' ||
    tabElement.classList.contains('active')

  if (isAlreadyActive) return

  tabElement.click()
}

export const createTabAutoClickHandler = (tabSelector: string) => {
  return (): void => {
    setTimeout(() => {
      autoClickSidePanelTab(tabSelector)
    }, 100)
  }
}

export const openRerunDialogManually = async (): Promise<void> => {
  try {
    if (await openBacktestRunDialogDirectly()) return
  } catch (error) {
    // Fallback to click
  }

  setTimeout(() => {
    if (isElementReady(selectors.rerunBacktestButton)) {
      const rerunButton = document.querySelector(selectors.rerunBacktestButton) as HTMLElement
      rerunButton.click()
    }
  }, 200)
}
